import React from 'react';
import { Box, Body, BoxProps } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';

interface Props extends BoxProps {
  message: string;
}

const HomeOwnerMessage: React.FC<Props> = ({ message, ...restProps }) => (
  <Box alignItems="flex-end" {...restProps}>
    <Box
      bg="neutral.0"
      py={300}
      px={500}
      maxW="230px"
      flexDir="column"
      alignItems="flex-end"
      shadow="distance300"
      borderRadius="8px"
      borderBottomRightRadius="0"
    >
      <Body
        textAlign="right"
        size={200}
        fontWeight={700}
        letterSpacing="1px"
        mb={100}
        color="green.500"
      >
        HOMEOWNER
      </Body>
      <Body textAlign="right" size={300} fontWeight={700}>
        {message}
      </Body>
    </Box>
    <StaticImage
      quality={100}
      placeholder="blurred"
      style={{ width: 108 }}
      alt="home owner"
      src="../../../../assets/images/home_owner.png"
    />
  </Box>
);

export default HomeOwnerMessage;
